const BLOOD_GROUPS = [
          "A RH Pozitif",
          "B RH Pozitif",
          "0 RH Pozitif",
          "AB RH Pozitif",
          "A RH Negatif",
          "B RH Negatif",
          "0 RH Negatif",
          "AB RH Negatif",
  ];

const TITLES = [
                      "GM",
                      "IM",
                      "FM",
                      "CM",
                      "NM",
                      "WGM",
                      "WIM",
                      "WFM",
                      "WCM"
                      ];

const GENDERS = [
                  "Erkek",
                  "Kadın",
                ];   



const NATIONALITIES = [
  "KKTC",
  "TC",
  "Diğer"
];

const REGIONS = [
  "LEFKOŞA",
  "MAĞUSA",
  "GİRNE", 
  "GÜZELYURT",
  "İSKELE",
  "LEFKE",
  "BEYARMUDU",
  "YENİ ERENKÖY"
];

const REFEREE_CLASSES = [
  "Fide Hakemi",
  "Ulusal Hakem",
  "1. Sınıf Hakem", 
  "2. Sınıf Hakem"
];

const COACH_CLASSES = [
  "1. Sınıf Antrenör", 
  "2. Sınıf Antrenör"
];

const VISA_STATUS = [
  "AKTİF", 
  "PASİF"
];

const MEMBER_YEARS = [
  "2024", 
  "ESKİ ÜYE"
];

const MEMBER_TYPES = [
  "ASİL ÜYE", 
  "KURUCU ÜYE",
  "İSTİFA",
];


const MEMBER_STATUSES = [
  "2024 YENİ ÜYE", 
  "2024 YILI İSTİFA",
  "İHRAÇ LİSTESİNDE",
  "MAHSUPLAŞMA",
  "YENİ ÜYE"
];

const TRANSACTION_TYPES = [
  "Üye Kayıt", 
  "Aidat Ödeme",
  "Kart Ücreti",
  "Yıllık Aidat Ücreti"
];

const MATCH_TYPES = [
  "Yurtiçi - İç Saha", 
  "Yurtiçi - Deplasman", 
  "Yurtdışı - Deplasman"
];

const COUNTRIES = [
  "Türkiye", 
  "KKTC"
];

const KINSHIPS = [
  "Kendisi", 
  "Eşi",
  "Çocuğu",
  
];

const DOCUMENT_TYPES = [
  "KKTC",
  "TC",
  "Güney Kıbrıs",
  "İngiltere",
  "Diğer"
];

const PAYMENT_TYPES = [
  "Kredi Kartı",
  "Havale",
  "Nakit",
  "Çek"
];

export default {
  TITLES: TITLES,
  GENDERS: GENDERS,
  NATIONALITIES: NATIONALITIES,
  REGIONS: REGIONS,
  REFEREE_CLASSES: REFEREE_CLASSES,
  COACH_CLASSES: COACH_CLASSES,
  VISA_STATUS: VISA_STATUS,
  BLOOD_GROUPS: BLOOD_GROUPS,
  MEMBER_YEARS: MEMBER_YEARS,
  MEMBER_TYPES: MEMBER_TYPES,
  MEMBER_STATUSES: MEMBER_STATUSES,
  TRANSACTION_TYPES: TRANSACTION_TYPES,
  MATCH_TYPES: MATCH_TYPES,
  COUNTRIES: COUNTRIES,
  KINSHIPS: KINSHIPS,
  DOCUMENT_TYPES: DOCUMENT_TYPES,
  PAYMENT_TYPES: PAYMENT_TYPES
}